import { request } from './client';

/**
 * 上传单个文件
 * @param {File} file - 文件对象
 * @param {number} labelId - 关联的标签ID（可选）
 */
export const uploadFile = async (file, labelId) => {
  const formData = new FormData();
  formData.append('file', file);
  if (labelId) {
    formData.append('labelId', labelId);
  }

  return request('/files/upload', {
    method: 'POST',
    body: formData,
  });
};

/**
 * 批量上传文件
 * @param {File[]} files - 文件数组
 * @param {number} labelId - 关联的标签ID（可选）
 */
export const uploadFiles = async (files, labelId) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });
  if (labelId) {
    formData.append('labelId', labelId);
  }

  return request('/files/upload/batch', {
    method: 'POST',
    body: formData,
  });
};

/**
 * 获取文件信息
 * @param {number} id - 文件ID
 */
export const fetchFileInfo = async (id) => {
  return request(`/files/${id}`, {
    method: 'GET',
  });
};

/**
 * 获取我的文件列表
 */
export const fetchMyFiles = async () => {
  return request('/files/my', {
    method: 'GET',
  });
};

/**
 * 删除文件
 * @param {number} id - 文件ID
 */
export const deleteFile = async (id) => {
  return request(`/files/${id}`, {
    method: 'DELETE',
  });
};

